module.exports = __webpack_public_path__ + "img/support.77c8ae54.jpg";